import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  noPadding?: boolean;
}
export function Card({
  className = '',
  children,
  noPadding = false,
  ...props
}: CardProps) {
  return <motion.div className={`bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden ${noPadding ? '' : 'p-6'} ${className}`} {...props} data-id="element-215">
      {children}
    </motion.div>;
}